const info_btn = ( e, d ) =>
{

  if ( !cached_elements.has_class( '.welcome', 'active' ) )
  {

    const active_section = sections.active.getAttribute( 'data-section' );

    cached_elements.set_text( '.welcome__btns--to-section > span', `Back to ${sections[active_section]}` );

    cached_elements.set_attribute( '.welcome__btns--to-section', 'data-backtosection', active_section );

    open_section( 'welcome' );

  }

  e.preventDefault();
}